import React, { useState, useEffect } from 'react';
import OfficeInfo from './components/OfficeInfo';
import ServiceList from './components/ServiceList';
import FullScreenMessage from "./components/FullScreenMessage";
import './App.css';
import { cqAPI } from "./lib/Auth";

const App = () => {
  const [officeData, setOfficeData] = useState({ services: [], business: {} });
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    cqAPI.get('/services')
      .then(data => {
        if (data.type === 'ok') {
          setOfficeData(data.data);
        } else {
          if (data.code) {
            setHasError(true);
          }
        }
        setIsLoading(false)
      })
      .catch(error => {
        setHasError(true);
        setIsLoading(false)
      });
  }, []);
  
  if (hasError) {
    return <FullScreenMessage message="This is not a valid link" />;
  }
  
  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div className="header">Choose a service</div>
      <OfficeInfo info={officeData.business} />
      <ServiceList services={officeData.services} onSelectService={(serviceId) => console.log(serviceId)} />
    </div>
  );
};

export default App;
